import moment from 'moment';

// Configurar o moment para português
moment.locale('pt-br');

/**
 * Formata uma data para exibição
 * @param {string|Date} date - Data para formatar
 * @param {string} format - Formato desejado (padrão: DD/MM/YYYY HH:mm)
 * @returns {string} Data formatada
 */
export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  if (!date) return '-';
  
  try {
    return moment(date).format(format);
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return '-';
  }
};

/**
 * Formata uma data para exibição apenas com data
 * @param {string|Date} date - Data para formatar
 * @returns {string} Data formatada (DD/MM/YYYY)
 */
export const formatDateOnly = (date) => {
  return formatDate(date, 'DD/MM/YYYY');
};

/**
 * Formata uma data para exibição apenas com hora
 * @param {string|Date} date - Data para formatar
 * @returns {string} Hora formatada (HH:mm)
 */
export const formatTimeOnly = (date) => {
  return formatDate(date, 'HH:mm');
};

/**
 * Verifica se uma data é válida
 * @param {string|Date} date - Data para validar
 * @returns {boolean} True se a data é válida
 */
export const isValidDate = (date) => {
  return moment(date).isValid();
};

/**
 * Converte uma data para o formato ISO para envio ao backend
 * @param {string|Date} date - Data para converter
 * @returns {string} Data no formato ISO
 */
export const toISOString = (date) => {
  if (!date) return null;
  return moment(date).toISOString();
};

/**
 * Calcula a diferença em dias entre duas datas
 * @param {string|Date} startDate - Data inicial
 * @param {string|Date} endDate - Data final
 * @returns {number} Diferença em dias
 */
export const diffInDays = (startDate, endDate) => {
  return moment(endDate).diff(moment(startDate), 'days');
};

/**
 * Verifica se uma data é anterior a outra
 * @param {string|Date} date1 - Primeira data
 * @param {string|Date} date2 - Segunda data
 * @returns {boolean} True se date1 é anterior a date2
 */
export const isBefore = (date1, date2) => {
  return moment(date1).isBefore(moment(date2));
};

/**
 * Verifica se uma data é posterior a outra
 * @param {string|Date} date1 - Primeira data
 * @param {string|Date} date2 - Segunda data
 * @returns {boolean} True se date1 é posterior a date2
 */
export const isAfter = (date1, date2) => {
  return moment(date1).isAfter(moment(date2));
}; 